import { render, staticRenderFns } from "./addMinNode.vue?vue&type=template&id=5afff3f5&scoped=true&"
import script from "./addMinNode.vue?vue&type=script&lang=js&"
export * from "./addMinNode.vue?vue&type=script&lang=js&"
import style0 from "./addMinNode.vue?vue&type=style&index=0&id=5afff3f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afff3f5",
  null
  
)

export default component.exports